var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "校验" } },
        [
          _c(
            "el-checkbox",
            {
              staticClass: "setting-validator_require",
              model: {
                value: _vm.isRequire,
                callback: function($$v) {
                  _vm.isRequire = $$v
                },
                expression: "isRequire"
              }
            },
            [_vm._v("\n                 必填")]
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showRuleSelect,
                  expression: "showRuleSelect"
                }
              ],
              staticClass: "setting-validator_rule",
              attrs: { placeholder: "请选择", clearable: "" },
              model: {
                value: _vm.ruleSelected,
                callback: function($$v) {
                  _vm.ruleSelected = $$v
                },
                expression: "ruleSelected"
              }
            },
            _vm._l(_vm.formValidatorRuleList, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLimit,
                  expression: "showLimit"
                }
              ],
              staticClass: "setting-validator_limit"
            },
            [
              _c("el-input", {
                attrs: { placeholder: "最小位数" },
                model: {
                  value: _vm.minValueProxy,
                  callback: function($$v) {
                    _vm.minValueProxy = _vm._n($$v)
                  },
                  expression: "minValueProxy"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("--")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "最大位数" },
                model: {
                  value: _vm.maxValueProxy,
                  callback: function($$v) {
                    _vm.maxValueProxy = _vm._n($$v)
                  },
                  expression: "maxValueProxy"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMoney,
                  expression: "showMoney"
                }
              ],
              staticClass: "setting-validator_money",
              model: {
                value: _vm.isMoney,
                callback: function($$v) {
                  _vm.isMoney = $$v
                },
                expression: "isMoney"
              }
            },
            [_vm._v("\n                 转大写")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ad867a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ad867a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingValidatorRule.vue
// module id = null
// module chunks = 